import { ArrayResource } from './ArrayResource.mjs';
export { ArrayResource } from './ArrayResource.mjs';
import { INSTALLED } from './autoDetectResource.mjs';
export { INSTALLED, autoDetectResource } from './autoDetectResource.mjs';
import { BufferResource } from './BufferResource.mjs';
export { BufferResource } from './BufferResource.mjs';
import { CanvasResource } from './CanvasResource.mjs';
export { CanvasResource } from './CanvasResource.mjs';
import { CubeResource } from './CubeResource.mjs';
export { CubeResource } from './CubeResource.mjs';
import { ImageBitmapResource } from './ImageBitmapResource.mjs';
export { ImageBitmapResource } from './ImageBitmapResource.mjs';
import { ImageResource } from './ImageResource.mjs';
export { ImageResource } from './ImageResource.mjs';
import { SVGResource } from './SVGResource.mjs';
export { SVGResource } from './SVGResource.mjs';
import { VideoResource } from './VideoResource.mjs';
export { VideoResource } from './VideoResource.mjs';
export { BaseImageResource } from './BaseImageResource.mjs';
export { Resource } from './Resource.mjs';
export { AbstractMultiResource } from './AbstractMultiResource.mjs';

INSTALLED.push(ImageBitmapResource, ImageResource, CanvasResource, VideoResource, SVGResource, BufferResource, CubeResource, ArrayResource);
//# sourceMappingURL=index.mjs.map
